export const PaymentPlansConfigurationsPermissions = {
  ViewPaymentPlans: {
    permissionsId: "7be4f4d6-618d-42f9-ec2d-08dd2fb527c1",
    permissionsName: "View Payment Plans",
    description: null,
    componentsId: null,
    components: null,
  },
};
